import React, { FC, useEffect } from 'react';
import { SCUIBreadCrumb, SCUITextFieldWithButton, SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUIContent } from '../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Button, Box } from '@mui/material';
import CacheQuery from '../../services/query/cache/CacheQuery.services';
import DeleteIcon from '@mui/icons-material/Delete';
import { CacheCommand } from '../../services/command';
import Swal from 'sweetalert2';

export const CacheTeam: FC<any> = () => {
    const [refresh, setRefresh] = React.useState(false);
    const [value, setValue] = React.useState('');
    const [CacheTeam, setCacheTeam] = React.useState([]);
    const { t } = useTranslation();

    // Helper function to handle successful deletion
    const handleSuccessfulDeletion = (res: any) => {
        console.info(res);
        Swal.fire(t('general.deleted'), ' ', 'success');
        setRefresh((prevRefreshing) => !prevRefreshing);
    };

    // Helper function to handle deletion error
    const handleDeletionError = (error: any) => {
        console.log('Hata :>> ', error);
    };

    // Helper function to perform the actual deletion
    const performDeletion = (params: any) => {
        console.info(params.id);
        CacheCommand.PostRemoveCacheTeam(params.id).then(handleSuccessfulDeletion).catch(handleDeletionError);
    };

    const sil = (params: any) => {
        Swal.fire({
            text: t('general.sureText') + ' ' + params.row.teamName,
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                performDeletion(params);
            }
        });
    };
    // Helper function to handle successful team addition
    const handleSuccessfulAddition = () => {
        Swal.fire(t('general.added'), ' ', 'success');
        setRefresh((prevRefreshing) => !prevRefreshing);
    };

    // Helper function to handle team addition error
    const handleAdditionError = (error: any) => {
        console.log('Hata :>> ', error);
    };

    // Helper function to add team
    const addTeam = (params: any) => {
        CacheCommand.PostTeam(params).then(handleSuccessfulAddition).catch(handleAdditionError);
    };

    const TakımEkle = async () => {
        const params = { request: { teamName: value } };

        if (value && value.trim().length > 0) {
            addTeam(params);
        } else {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
        }
    };
    const handleOnCellClick = (params: any) => {
        if (params.field === 'sil') sil(params);
    };
    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID ', width: 250 },
        {
            field: 'teamName',
            headerName: t('cacheManagement.teamName'),
            width: 650,
            editable: false,
        },
        {
            field: 'sil',
            headerName: t('general.delete'),
            editable: false,
            renderCell: () => {
                return (
                    <Button className="cache-team-row-delete-button">
                        <DeleteIcon fontSize="large" />
                    </Button>
                );
            },
        },
    ];

    const getTeam = async () => {
        try {
            let team: any = await CacheQuery.ListEcommerceTeam();
            setCacheTeam(team.data);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };

    useEffect(() => {
        getTeam();
    }, [refresh]);

    return (
        <SCUIContent>
            <Box className="cache-team">
                <Grid className="cache-team-header" container>
                    <SCUIBreadCrumb title={t('dashboard.cacheTeam')} componentLink={'CacheTeam'} />
                    <Grid className="cache-team-add-input" size={{ xs: 12 }}>
                        <SCUITextFieldWithButton
                            buttonText={t('general.add')}
                            placeholder={t('cacheManagement.teamName')}
                            onChange={(event: any) => {
                                setValue(event.target.value);
                            }}
                            onClick={() => TakımEkle()}
                            onKeyPress={(e: any) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    TakımEkle();
                                }
                            }}
                        />
                    </Grid>

                    <Grid className="cache-team-data-grid" size={{ xs: 12 }}>
                        <SCUICustomDataGrid rows={CacheTeam} columns={columns} onCellClick={handleOnCellClick} />
                    </Grid>
                </Grid>
            </Box>
        </SCUIContent>
    );
};
